import { FileType } from '@office-start/document-types';
// TODO: Localize the values that are displayed before we start showing new file types
// Used for document icon hover titles, collection keys, and setting the Shell title on WAC start pages.
export function getFileTypeNameFromType(fileType) {
    switch (fileType) {
        case FileType.Word:
            return 'Word';
        case FileType.Excel:
            return 'Excel';
        case FileType.PowerPoint:
            return 'PowerPoint';
        case FileType.MeetingNotes:
        case FileType.OneNote:
        case FileType.OneNoteClassNoteBook:
        case FileType.OneNotePage:
            return 'OneNote';
        case FileType.Pdf:
            return 'PDF';
        case FileType.Visio:
            return 'Visio';
        case FileType.Audio:
            return 'Audio';
        case FileType.Video:
            return 'Video';
        case FileType.Photos:
            return 'Photos';
        case FileType.Outlook:
            return 'Outlook';
        case FileType.Text:
            return 'Text';
        case FileType.Sway:
            return 'Sway';
        case FileType.Forms:
        case FileType.FormsQuiz:
            return 'Forms';
        case FileType.Project:
            return 'Project';
        case FileType.ProjectOperations:
            return 'ProjectOperations';
        case FileType.Portfolio:
            return 'Portfolio';
        case FileType.NewsArticle:
            return 'NewsArticle';
        case FileType.Fluid:
            return 'Loop components';
        case FileType.PowerBI:
            return 'PowerBI';
        case FileType.StreamsVideo:
            return 'Streams';
        case FileType.Stream:
            return 'Stream';
        case FileType.ScreenRecording:
            return 'ScreenRecording';
        case FileType.UpcomingMeeting:
            return 'UpcomingMeeting';
        case FileType.List:
            return 'List';
        case FileType.PlayLists:
            return 'PlayLists';
        case FileType.PlayList:
            return 'PlayList';
        case FileType.Spaces:
            return 'Spaces';
        case FileType.MindMeister:
            return 'MindMeister';
        case FileType.Monday:
            return 'monday.com';
        case FileType.Trello:
            return 'Trello';
        case FileType.Platform:
            return 'Platform';
        case FileType.Whiteboard:
            return 'Whiteboard';
        case FileType.MeetingObject:
            return 'MeetingObject';
        case FileType.ThirdParty:
            return 'Custom';
        case FileType.MyAnalytics:
            return 'MyAnalytics';
        default:
            return 'Document';
    }
}
//# sourceMappingURL=getFileTypeNameFromType.js.map